module.exports = __webpack_public_path__ + "static/media/modelo_gestion_cuadro3.ee38a0ca.png";